import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { userApi } from "../../sharedfiles/EndpointConfig";
import { toaster } from "../../sharedfiles/helper";

export const createPermissionSlice = createSlice({
  name: "createPermission",
  initialState: {
    permissionData: [],
    permissionList: { data: [], totalRecords: 0 },
    clientData: { id: "", name: "", },
    permissionFiledData: { value: "", error: false },
    userRolePermissionList: [],
    paginationFirstValue: 1,
    paginationSecondValue: 25,
    recordsShow: 25,
    isVisible: false,
    docsData: [],
    pdfData: [],
  },
  reducers: {
    setPermissionData: (state, action) => {
      state.permissionData = action.payload;
    },
    setPermissionList: (state, action) => {
      state.permissionList = action.payload;
    },
    setClientData: (state, action) => {
      state.clientData = action.payload;
    },
    setPermissionFieldData: (state, action) => {
      state.permissionFiledData = action.payload;
    },
    setUserRolePermissionList: (state, action) => {
      state.userRolePermissionList = action.payload;
    },
    setPaginationFirstValue: (state, action) => {
      state.paginationFirstValue = action.payload;
    },
    setPaginationSecondValue: (state, action) => {
      state.paginationSecondValue = action.payload;
    },
    setRecordsShow: (state, action) => {
      state.recordsShow = action.payload;
    },
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setDocsData: (state, action) => {
      state.docsData = action.payload;
    },
    setPdfData: (state, action) => {
      state.pdfData = action.payload;
    },
  },
});
export const {
  setPermissionData,
  setPermissionList,
  setClientData,
  setPermissionFieldData,
  setUserRolePermissionList,
  setPaginationFirstValue,
  setPaginationSecondValue,
  setRecordsShow,
  setIsVisible,
  setDocsData,
  setPdfData,
} = createPermissionSlice.actions;

export const getPermissionCreate = (params) => (dispatch) => {
  //dev.platform-ups.negroup-tech.net:443/role/permission/create
  //dev.platform-ups.negroup-tech.net/permission/create
  var obj = {
    permissionName: [params.permissionName],
    clientId: params.clientId,
  };
  var url = `${userApi.getPermissionCreate}`;
  apiCaller(url, "POST", obj)
    .then((response) => {
      if (response !== null && response) {
        dispatch(setPermissionData(response.data));
        toaster.success("SUCCESS");
        [400, 401, 500].includes(response.status) &&
          toaster.error("ERROR");
      }
    })
    .catch((error) => {
      toaster.error("ERROR");
    });
};

export const getRolePermission = (pageNumber = 0, itemsPerPage = 25) => (dispatch) => {
  let url = `${userApi.getRolePermission}?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}`;
  apiCaller(url, "GET").then((response) => {
    if (response && response.data) {
      // Handle both paginated response {data: [], totalRecords: number} and direct array response
      const isArrayResponse = Array.isArray(response.data);
      const permissionData = isArrayResponse
        ? { data: response.data, totalRecords: response.data.length }
        : response.data;
      dispatch(setPermissionList(permissionData));
      dispatch(setIsVisible(true));
    }
  }).catch((err) => {
    dispatch(setPermissionList({ data: [], totalRecords: 0 }));
    dispatch(setIsVisible(true));
  });
};

export const getUserRolePermissionV2 = () => (dispatch) => {
  let url = userApi.getUserPermission;
  apiCaller(url, "GET").then((response) => {
    if (response && response.data) {
      dispatch(setUserRolePermissionList(response.data));
    }
  }).catch(() => { });
};

export const editRole = (item) => (dispatch) => {
  let url = `${userApi.getAssignRole}`;
  const data = {
    roleId: item.roleId,
    roles: item.permissionId,
    userId: item.userId,
    // perName: item.perName,
  };
  apiCaller(url, "POST", data)
    .then((response) => {
      if (response && response.data) {
        toaster.success("SUCCESS");
      }
    })
    .catch((error) => {
      toaster.error("ERROR");
    });
};

export default createPermissionSlice.reducer;
